import { useTranslation } from "react-i18next";
import { StaggeredContainer, StaggeredItem } from "../../animations/staggeredFadeIn";
import Bikes from "../Bikes";
import Cruises from "../Cruises";
import Houses from "../Houses";
import { Description } from "../styled";
import { Section, Header, DescriptionSection, ImageWrapper, Image } from "./styled";

const ContentSection = ({ id, variant, imageSrc }) => {
    const { t } = useTranslation();

    const titleKey = `sections.${variant}.title`;
    const descKey = `sections.${variant}.description`;
    const altKey = `sections.${variant}.imageAlt`;

    return (
        <Section id={id}>
            <StaggeredContainer>
                <StaggeredItem>
                    <Header className="mobile-header">{t(titleKey)}</Header>
                </StaggeredItem>
            </StaggeredContainer>
            <ImageWrapper $imageSrc={imageSrc}>
                <Image src={imageSrc} alt={t(altKey)} width="1200" height="675" loading="lazy"/>
                <Header className="desktop-header">{t(titleKey)}</Header>
            </ImageWrapper>
            <DescriptionSection>
                <StaggeredContainer>
                    <StaggeredItem>
                        <Description>{t(descKey)}</Description>
                    </StaggeredItem>
                </StaggeredContainer>

                {variant === "cruises" && <Cruises />}
                {variant === "houses" && <Houses />}
                {variant === "bikes" && <Bikes />}
            </DescriptionSection>
        </Section>
    );
};

export default ContentSection;